export default __webpack_public_path__ + "static/innovation-c369299d471b77612bd1438087fdb04f.png";